import React, { useState } from "react";
import { TextField, Button, Grid, Paper, Typography } from "@mui/material";
import Swal from "sweetalert2";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const handleAddContact = async (e) => {
    e.preventDefault();

    if (!name || !email || !subject || !message) {
      Swal.fire("Error", "All fields are required!", "error");
      return;
    }

    const contactData = {
      name,
      email,
      subject,
      message,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/add-contact`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(contactData),
        }
      );

      const result = await response.json();

      if (response.status === 201) {
        Swal.fire("Success", result.message, "success");

        // 🔥 WhatsApp message with all details and timestamp
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleString();

        const whatsappMessage = `New Contact Submission:\n\nName: ${name}\nEmail: ${email}\nSubject: ${subject}\nMessage: ${message}\nDate & Time: ${formattedDate}`;

        const phoneNumber = "918602191633";
        const encodedMessage = encodeURIComponent(whatsappMessage);
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

        window.open(whatsappURL, "_blank");

        setName("");
        setEmail("");
        setSubject("");
        setMessage("");
      } else {
        Swal.fire("Error", result.message, "error");
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };

  return (
    <Grid
      container
      id="contact"
      sx={{ backgroundColor: "aliceblue" }}
      className="mt-5"
    >
      {/* Left Side with Google Map */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          height: "100vh",
          alignContent: "center",
          textAlign: "center",
        }}
      >
        <iframe
          title="Doctor Service At Home Location"
          width="100%"
          height="450"
          frameBorder="0"
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1789.8879434970895!2d78.20007305628761!3d26.203967732935276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3976c53c39c3d8b1%3A0x242984e24a3e2dfd!2sDoctor%20Service%20At%20Home!5e0!3m2!1sen!2sin!4v1753765944832!5m2!1sen!2sin"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Grid>

      {/* Right Side with Form */}
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "20px",
        }}
      >
        <Paper sx={{ width: "100%", padding: 4 }}>
          <Typography
            variant="h5"
            align="center"
            sx={{ marginBottom: 4, fontWeight: "bold" }}
          >
            Make an Enquiry
          </Typography>
          <form onSubmit={handleAddContact}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Full Name"
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Email"
                  variant="outlined"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Subject"
                  variant="outlined"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Message"
                  variant="outlined"
                  multiline
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  fullWidth
                  variant="contained"
                  type="submit"
                  color="primary"
                  className="fw-bold"
                >
                  Add Enquiry
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Contact;
